import { createApi } from '@reduxjs/toolkit/query/react'
import { baseQuery } from 'utils/base-query.js'

// Define a service using a base URL and expected endpoints
export const leadUsageApi = createApi({
  reducerPath: 'leadUsageApi',
  tagTypes: ['LEAD-USAGE'],
  baseQuery,
  endpoints: (builder) => ({
    getPartnerAndPartnerUsers: builder.query({
      query: (params) => {
        return {
          method: 'GET',
          url: '/admin/get-partner-and-users',
          params
        }
      }
    }),
    getPlans: builder.query({
      query: (params) => {
        return {
          method: 'GET',
          url: '/admin/getPlans',
          params
        }
      }
    }),
    getUsersUsedCredit: builder.query({
      query: ({ workspaceId }) => {
        return {
          method: 'GET',
          url: `/admin/get-users-credits/${workspaceId}`
        }
      }
    }),
    getUsersByCreditUsage: builder.query({
      query: ({ creditFilter }) => {
        return {
          method: 'GET',
          url: `/admin/get-users-by-credit-usage?creditFilter=${creditFilter}`
        }
      }
    }),
    getUserPlanAssignment: builder.query({
      query: ({ workspaceId }) => {
        return {
          method: 'GET',
          url: `/admin/get-plan-assignment/${workspaceId}`
        }
      }
    }),
    getPlanLogs: builder.query({
      query: (body) => {
        return {
          url: '/admin/getAllPlanLog',
          method: 'POST',
          body
        }
      }
    }),
    getUsersAggreUsage: builder.query({
      query: () => {
        return {
          method: 'GET',
          url: '/admin/get-users-aggregate-usage'
        }
      }
    })
  })
})

export const {
  useGetPartnerAndPartnerUsersQuery,
  useGetPlansQuery,
  useLazyGetUsersUsedCreditQuery,
  useGetUsersByCreditUsageQuery,
  useGetUserPlanAssignmentQuery,
  useGetPlanLogsQuery,
  useGetUsersAggreUsageQuery
} = leadUsageApi
